/* @generated */

// ../src/form_row/form_control_group.tsx
import * as React from "react";
import classNames from "classnames";

// ../src/form_row/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var formControlGroup = "dig-uq5i9o6_21-7-0";
var formHelperTextRecipe = _7a468({ defaultClassName: "dig-uq5i9od_21-7-0", variantClassNames: { variant: { warning: "dig-uq5i9oe_21-7-0", success: "dig-uq5i9of_21-7-0", alert: "dig-uq5i9og_21-7-0", "default": "dig-uq5i9oh_21-7-0" }, alignRight: { true: "dig-uq5i9oi_21-7-0" }, flex: { true: "dig-uq5i9oj_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });
var formLabelRecipe = _7a468({ defaultClassName: "dig-uq5i9o7_21-7-0", variantClassNames: { variant: { field: "dig-uq5i9o8_21-7-0", control: "dig-uq5i9o9_21-7-0" }, withInput: { true: "dig-uq5i9oa_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });
var formLabelSubtext = "dig-uq5i9ob_21-7-0";
var formLabelWrapper = "dig-uq5i9oc_21-7-0";
var formRowRecipe = _7a468({ defaultClassName: "dig-uq5i9o0_21-7-0", variantClassNames: { split: { true: "dig-uq5i9o1_21-7-0" }, footer: { true: "dig-uq5i9o2_21-7-0" }, variant: { field: "dig-uq5i9o3_21-7-0", control: "dig-uq5i9o4_21-7-0", button: "dig-uq5i9o5_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });

// ../src/form_row/form_control_group.tsx
var FormControlGroup = ({
  children,
  className,
  ...rest
}) => {
  const cls = classNames("dig-FormControlGroup", formControlGroup, className);
  return /* @__PURE__ */ React.createElement("fieldset", { className: cls, ...rest }, children);
};

// ../src/form_row/form_helper_text.tsx
import * as React2 from "react";
import classNames2 from "classnames";
var FormHelperText = ({
  alignRight = false,
  flex = true,
  variant = "default",
  children,
  ...rest
}) => {
  const cls = classNames2(
    "dig-FormHelperText",
    `dig-FormHelperText--${variant}`,
    {
      "dig-FormHelperText--alignRight": alignRight,
      "dig-FormHelperText--flex": flex
    },
    formHelperTextRecipe({ variant, alignRight, flex })
  );
  return /* @__PURE__ */ React2.createElement("div", { className: cls, ...rest }, children);
};
FormHelperText.displayName = "FormHelperText";

// ../src/form_row/form_label.tsx
import * as React3 from "react";
import classNames3 from "classnames";
var FormLabel = ({
  children,
  className,
  htmlFor,
  subtext,
  tagName: TagName = "label",
  variant = "field",
  withInput,
  ...rest
}) => {
  const cls = classNames3(
    "dig-FormLabel",
    {
      [`dig-FormLabel--${variant}`]: !!variant,
      "dig-FormLabel--withInput": !!withInput
    },
    formLabelRecipe({ variant, withInput: !!withInput }),
    className
  );
  return /* @__PURE__ */ React3.createElement(TagName, { className: cls, htmlFor, ...rest }, /* @__PURE__ */ React3.createElement(TextWrapper, { shouldWrap: !!withInput }, children, subtext && /* @__PURE__ */ React3.createElement("span", { className: classNames3("dig-FormLabel-subtext", formLabelSubtext) }, subtext)), withInput);
};
var TextWrapper = ({
  shouldWrap,
  children
}) => {
  return shouldWrap ? /* @__PURE__ */ React3.createElement("span", { className: classNames3("dig-FormLabel-wrapper", formLabelWrapper) }, children) : /* @__PURE__ */ React3.createElement(React3.Fragment, null, children);
};
FormLabel.displayName = "FormLabel";

// ../src/form_row/form_row.tsx
import * as React4 from "react";
import classNames4 from "classnames";
var FormRow = ({
  split = false,
  variant,
  isFooter = false,
  children
}) => {
  const cls = classNames4(
    "dig-FormRow",
    {
      "dig-FormRow--split": split,
      "dig-FormRow--footer": isFooter,
      [`dig-FormRow--${variant}`]: variant
    },
    formRowRecipe({ split, footer: isFooter, variant })
  );
  return /* @__PURE__ */ React4.createElement("div", { className: cls }, children);
};
FormRow.displayName = "FormRow";
export {
  FormControlGroup,
  FormHelperText,
  FormLabel,
  FormRow
};
